import BoolField       from 'uniforms-antd/BoolField';
import DateField       from 'uniforms-antd/DateField';
import HiddenField     from 'uniforms-antd/HiddenField';
import ListField       from 'uniforms-antd/ListField';
import NestField       from 'uniforms-antd/NestField';
import NumField        from 'uniforms-antd/NumField';
import connectField    from 'uniforms/connectField';
import filterDOMProps  from 'uniforms/filterDOMProps';
import invariant       from 'fbjs/lib/invariant';
import { createElement } from 'react';

import TabsField from './TabsField';
import TextField       from './TextField';
import RadioField      from './RadioField';
import SliderField from './SliderField';
import StaticField from './StaticField';
import LongTextField     from './LongTextField';
import SelectField     from './SelectField';

filterDOMProps.register('fieldComponent');

const Auto = ({component, ...props}) => {
    if (component === undefined) {
        if (props.fieldComponent) {
            if (props.fieldType === Array && props.fieldComponent !== 'foreignmultiselect') {
                if (props.fieldComponent === 'tabs') {
                    component = TabsField;
                } else {
                    component = ListField;
                }
            } else {
                switch (props.fieldComponent) {
                    case 'hidden':
                        component = HiddenField;
                        break;
                }
                invariant(component, 'Unsupported field component: %s', props.fieldComponent);
            }
        } else if (props.allowedValues) {
            if (props.checkboxes && props.fieldType !== Array) {
                component = RadioField;
            } else {
                component = SelectField;
            }
        } else if (props.html) {
                component = StaticField;
        } else {
            switch (props.fieldType) {
                case Date:    component = DateField; break;
                case Array:   component = ListField; break;
                case Number:  component = props.min !== undefined && props.max !== undefined ? SliderField : NumField; break;
                case Object:  component = NestField; break;
                case String:  component = props.rows ? LongTextField : TextField; break;
                case Boolean: component = BoolField; break;
            }

            invariant(component, 'Unsupported field type: %s', props.fieldType.toString());
        }
    }

    return createElement(component, props);
};

export default connectField(Auto, {ensureValue: false, includeInChain: false, initialValue: false});



// WEBPACK FOOTER //
// ./src/components/UI/uniforms/AutoField.js